import { Grid, GridAreas, StyledFlex, StyledMargin } from '@dreryk/react-components';

import { QUANTITY_WIDTH } from '../../prescriptionGrid.constants';

type DraftMagistralDrugPrescriptionGridProps = {
   readonly dosage: JSX.Element;
   readonly issuedFrom?: JSX.Element;
   readonly quantity?: JSX.Element;
   readonly issuedTo?: JSX.Element;
   readonly activeIngredients?: JSX.Element;
   readonly additionalEntitlements?: JSX.Element;
   readonly additionalRequirements?: JSX.Element;
};

type AREA = 'dosage' | 'issuedFrom' | 'additionalEntitlements' | 'additionalRequirements';

const AREAS: GridAreas<AREA> = {
   small: {
      template: [
         'dosage dosage dosage',
         'issuedFrom issuedFrom issuedFrom',
         'additionalEntitlements additionalRequirements additionalRequirements',
      ],
   },
};

export const DraftMagistralDrugPrescriptionGrid = (props: DraftMagistralDrugPrescriptionGridProps): JSX.Element => {
   const {
      dosage,
      issuedFrom,
      quantity,
      issuedTo,
      activeIngredients,
      additionalEntitlements,
      additionalRequirements,
   } = props;
   return (
      <Grid<AREA>
         areas={AREAS}
         testId={'draftMagistralDrugPrescription'}
         compact
         dosage={dosage}
         issuedFrom={
            <StyledFlex direction={'row'} gap={'8px'}>
               <StyledFlex flex={'1'}>{issuedFrom}</StyledFlex>
               <StyledFlex flex={`0 0 ${QUANTITY_WIDTH}`}>{quantity}</StyledFlex>
               <StyledFlex direction={'column'} gap={'2px'} alignItems={'center'} flex={'192px 0 0'}>
                  <StyledMargin top={18}>
                     {issuedTo}
                     {activeIngredients}
                  </StyledMargin>
               </StyledFlex>
            </StyledFlex>
         }
         additionalEntitlements={additionalEntitlements}
         additionalRequirements={additionalRequirements}
      />
   );
};
